export default function DynamicLoader({ loading, message }) {
  // If loading is a string, use it as the message
  const dynamicMessage = typeof loading === 'string' ? loading : message;
  const isLoading = loading || loading === true || typeof loading === 'string';

  return (
    <div className={`
        fixed inset-0 flex flex-col items-center justify-center
        bg-black/70 z-50
        transition-opacity duration-1000 ease-in-out
        ${isLoading ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'}
      `}>
      <div className="flex flex-col items-center">
        <div className="flex space-x-2 mb-4">
          {[...Array(3)].map((_, i) => (
            <div
              key={i}
              className="w-4 h-4 bg-indigo-400 rounded-full animate-ping"
              style={{ animationDelay: `${i * 0.2}s` }}
            />
          ))}
        </div>
        <div className="h-6">
          {dynamicMessage && (
            <p className={`
              text-white shadow-lg text-opacity-70 text-center text-sm
              transition-all duration-1000 ease-in-out
              ${isLoading ? 'opacity-100' : 'opacity-0'}
            `}>
              {dynamicMessage}
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
